import { useTranslation } from "react-i18next";

const WelcomeModal: React.FC<any> = (props) => {
  const { onClose } = props;
  const { t } = useTranslation("radar");

  return (
    <div className="welcome-modal">
      <div className="welcome-modal-content">
        <h1>{t("pages.Home.welcomeTitle")}</h1>
        <p>{t("pages.Home.welcomeText")}</p>
        <button className="botao-azul-degrade-vazado" onClick={onClose}>
          {t("pages.Home.welcomeButton")}
        </button>
      </div>
    </div>
  );
};

export default WelcomeModal;
